import { useRouteLoaderData, Link, Outlet } from 'react-router';
import useIsAdmin from '@/hooks/useIsAdmin';
import PathwayRow from '@/components/pathways/PathwayRow';
import { resourcesActions, useNextPathways, usePathways } from '@/stores/resourcesStore';
import LoadMoreButton from '@/components/core/LoadMoreButton';
import featureConfig from '@/featureConfig';
import Instructions from './Instructions';
import PathwayTemplates from './PathwayTemplates';

const MoocHomeRoute = () => {
  const {
    project: { id },
  } = useRouteLoaderData('project');

  const nextPathways = useNextPathways();
  const pathways = usePathways();
  const isAdmin = useIsAdmin();

  const loadMore = () => {
    resourcesActions.loadMorePathways(id);
  };

  return (
    <div className="overflow-y-scroll">
      <div className="flex">
        <div className="p-4 w-2/3">
          <PathwayTemplates />
          <div className="flex items-center justify-between mr-6">
            <p className="text-lg font-semibold">My Configurations ({pathways.length})</p>
            {featureConfig.enablePathwayAdding && (
              <Link to={`pathways/new`} className="btn btn-secondary btn-xs">
                Add Pathway
              </Link>
            )}
          </div>

          <p className="text-sm text-gray-600 mt-3 mr-6 pb-2 border-b border-gray-200">
            Your custom pathway configurations and analysis results. You can create new configurations from scratch or modify existing templates to fit your specific analysis requirements
          </p>

          <div className="mt-4">
            <table className="w-full text-left text-sm">
              <thead>
                <tr className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <th className="text-left w-1/4 py-2 px-4">Name</th>
                  <th className="text-left w-1/4 py-2 px-4">&nbsp;Status</th>
                  <th className="text-left w-1/4 py-2 px-4">Created</th>
                  <th className="text-left w-1/4 py-2 px-4">Last Updated</th>
                  <th className="text-right py-2 px-4"></th>
                </tr>
              </thead>
              <tbody>
                {pathways.map((pathway, index) => (
                  <PathwayRow key={index} pathway={pathway} projectId={id} isAdmin={isAdmin} />
                ))}
              </tbody>
            </table>
          </div>

          <LoadMoreButton
            onLoadMore={loadMore}
            hasMore={!!nextPathways}
            className="btn btn-sm btn-outline"
            buttonText="Load more"
          />
        </div>

          <div className="w-1/3 p-4">
            <Instructions />
          </div>

      </div>
      <Outlet />
    </div>
  );
};

export default MoocHomeRoute;
